import {StatisticParams} from '@wix/music-player';
import {EventEmitter} from 'events';
import {fedopsLogger} from '../logging/fedops';
import {filterInEditor} from '../widget-player/popus/featureDisabledPopup';

export function logToFedops(statisticsEventsEmitter: EventEmitter) {
  statisticsEventsEmitter.on(
    'trackPlayAttempt',
    filterInEditor()(({isAutoplay}: StatisticParams) => {
      if (isAutoplay) {
        return;
      }
      fedopsLogger.interactionStarted('track-play');
    }),
  );
  statisticsEventsEmitter.on(
    'trackPlayStart',
    filterInEditor()(({isAutoplay}: StatisticParams) => {
      if (isAutoplay) {
        return;
      }
      fedopsLogger.interactionEnded('track-play');
    }),
  );
}
